'use client';
import { Card, cardStyles } from '@/app/[lang]/price-chart/[category]/[symbol]/components/Card';
import { useSignupForAssetModal } from '@/app/[lang]/price-chart/[category]/[symbol]/components/WithSignupForAsset/WithSignupForAsset';
import styles from './styles.module.scss';
import buttons from '@/styles/button.module.scss';
import typography from '@/styles/typography.module.scss';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

export function NotTradedWidget() {
  const { openSignupForAssetDialog } = useSignupForAssetModal();
  const tr = useTranslations();
  return (
    <Card className={classNames(cardStyles.cardPaddingRegular)} innerClassName={styles.cardSignupForAsset}>
      <button
        onClick={openSignupForAssetDialog}
        className={classNames(buttons.btn, buttons.btnPrimary, buttons.btnS)}
      >
        {tr.rich('pages.priceCharts.asset.sections.sidebar.nonTradeable.cta')}
      </button>
      <p className={typography.bodyM}>
        {tr.rich('pages.priceCharts.asset.sections.sidebar.nonTradeable.description')}
      </p>
    </Card>
  );
}
